module.exports = __webpack_public_path__ + "img/kcpd.85ec8f69.png";